// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Atom_Cta = require("../atom/Atom_Cta.bs.js");
var Atom_Row = require("../atom/Atom_Row.bs.js");
var Atom_Cell = require("../atom/Atom_Cell.bs.js");
var Atom_Text = require("../atom/Atom_Text.bs.js");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Atom_Icon_Mona = require("../atom/icon/Atom_Icon_Mona.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function Molecule_EventInfo(Props) {
  var linkInfo = Props.linkInfo;
  var linkTerms = Props.linkTerms;
  var dateEvent = Props.dateEvent;
  var $$location = Props.location;
  return React.createElement(Atom_Column.make, {
              alignItems: Particle_Screen_Constants.alignItemsFlexStart,
              children: null,
              innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
            }, React.createElement(Atom_Row.make, {
                  alignItems: Particle_Screen_Constants.alignItemsCenter,
                  children: null,
                  wrap: /* OnOneLine */1
                }, React.createElement(Atom_Cell.make, {
                      blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("S")),
                      children: React.createElement(Atom_Icon_Mona.make, {
                            icon: "MapMarker"
                          })
                    }), React.createElement(Atom_Text.Mona.make, {
                      variant: "eventInfo",
                      children: $$location
                    })), React.createElement(Atom_Row.make, {
                  alignItems: Particle_Screen_Constants.alignItemsCenter,
                  children: null,
                  wrap: /* OnOneLine */1
                }, React.createElement(Atom_Cell.make, {
                      blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("S")),
                      children: React.createElement(Atom_Icon_Mona.make, {
                            icon: "Calendar"
                          })
                    }), React.createElement(Atom_Text.Mona.make, {
                      variant: "eventInfo",
                      children: dateEvent
                    })), React.createElement(Atom_Cta.Mona.Link.make, {
                  label: linkInfo.label,
                  href: linkInfo.href,
                  variant: "eventLink"
                }), React.createElement(Atom_Cta.Mona.Link.make, {
                  label: linkTerms.label,
                  href: linkTerms.href,
                  variant: "eventLink"
                }));
}

var make = Molecule_EventInfo;

exports.make = make;
/* react Not a pure module */
